import type { RequiredScopes, Scope } from '@utamed/auth-module';

export type { RequiredScopes, RequiredScopesMode, Scope } from '@utamed/auth-module';

/**
 * ====================================
 * SCOPES PERSONAS
 * ====================================
 */
export const PERSONAS_SCOPE_READ_PERSONA: Scope = 'persona:read';
export const PERSONAS_SCOPE_READ_USUARIO: Scope = 'usuario:read';
export const PERSONAS_SCOPE_WRITE_PERSONA: Scope = 'persona:write';
export const PERSONAS_SCOPE_WRITE_USUARIO: Scope = 'usuario:write';

export const PERSONAS_REQUIRED_SCOPES_READ: RequiredScopes = {
  scopes: [PERSONAS_SCOPE_READ_PERSONA, PERSONAS_SCOPE_READ_USUARIO],
  mode: 'any',
};

/**
 * ====================================
 * SCOPES AUTHORIZATION
 * ====================================
 */
export const AUTH_SCOPE_READ_API: Scope = 'api:read';
export const AUTH_SCOPE_READ_CLIENT: Scope = 'client:read';
export const AUTH_SCOPE_READ_AUDIT: Scope = 'audit:read';
export const AUTH_SCOPE_WRITE_API: Scope = 'api:write';
export const AUTH_SCOPE_WRITE_CLIENT: Scope = 'client:write';

export const AUTH_REQUIRED_SCOPES_READ: RequiredScopes = {
  scopes: [AUTH_SCOPE_READ_API, AUTH_SCOPE_READ_CLIENT, AUTH_SCOPE_READ_AUDIT],
  mode: 'any',
};

/**
 * ====================================
 * SCOPES MAILER-HUB
 * ====================================
 */
export const MAILER_HUB_SCOPE_READ: Scope = 'email:read';

/**
 * ====================================
 * SCOPES MESSENGER-MONITOR
 * ====================================
 */
export const MESSENGER_MONITOR_SCOPE_READ: Scope = 'messenger-monitor:read';
export const MESSENGER_MONITOR_SCOPE_MANAGE_MESSAGES: Scope = 'messenger-monitor:manage-messages';
export const MESSENGER_MONITOR_SCOPE_WRITE: Scope = 'messenger-monitor:write';

/**
 * ====================================
 * SCOPES PLANES DE ESTUDIO
 * ====================================
 */
export const PLANES_ESTUDIOS_SCOPE_READ: Scope = 'planes-estudios:read';
export const PLANES_ESTUDIOS_SCOPE_WRITE: Scope = 'planes-estudios:write';

export const PLANES_ESTUDIOS_REQUIRED_SCOPES_READ: RequiredScopes = {
  scopes: [PLANES_ESTUDIOS_SCOPE_READ],
};

/**
 * ====================================
 * SCOPES GENERALES
 * ====================================
 */
export const GENERALES_SCOPE_READ_GEOGRAFICOS: Scope = 'geograficos:read';

export const ALL_SCOPES: Set<Scope> = new Set([
  PERSONAS_SCOPE_READ_PERSONA,
  PERSONAS_SCOPE_READ_USUARIO,
  PERSONAS_SCOPE_WRITE_PERSONA,
  PERSONAS_SCOPE_WRITE_USUARIO,
  AUTH_SCOPE_READ_API,
  AUTH_SCOPE_READ_CLIENT,
  AUTH_SCOPE_READ_AUDIT,
  AUTH_SCOPE_WRITE_API,
  AUTH_SCOPE_WRITE_CLIENT,
  MAILER_HUB_SCOPE_READ,
  MESSENGER_MONITOR_SCOPE_READ,
  MESSENGER_MONITOR_SCOPE_MANAGE_MESSAGES,
  MESSENGER_MONITOR_SCOPE_WRITE,
  PLANES_ESTUDIOS_SCOPE_READ,
  PLANES_ESTUDIOS_SCOPE_WRITE,
  GENERALES_SCOPE_READ_GEOGRAFICOS,
]);

/** Query param para avisar en login de falta de permisos. */
export const LOGIN_MISSING_PERMISSIONS_REASON = 'missing_permissions';

/** Permisos mínimos para permitir acceso a la app de administración: lectura en cualquiera de las APIs. */
export const APP_ACCESS_REQUIRED_SCOPE_SETS: (RequiredScopes | Scope)[] = [
  PERSONAS_REQUIRED_SCOPES_READ,
  AUTH_REQUIRED_SCOPES_READ,
  MAILER_HUB_SCOPE_READ,
  MESSENGER_MONITOR_SCOPE_READ,
  PLANES_ESTUDIOS_REQUIRED_SCOPES_READ,
  GENERALES_SCOPE_READ_GEOGRAFICOS,
];
